import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-esi-footer',
    template: `<esi-factory-ng view="footer"></esi-factory-ng>`,
    standalone: false,
})
export class EsiFooterComponent {
    constructor() {}
}
